export const card = [
  // 놀이/여가
  { name: '게임', imageUrl: '/assets/word_card/images/game.png', audioUrl: '/assets/word_card/audio/game.mp3' },
  { name: '놀이터', imageUrl: '/assets/word_card/images/playground.png', audioUrl: '/assets/word_card/audio/playground.mp3' },
  { name: '시계', imageUrl: '/assets/word_card/images/clock.gif', audioUrl: '/assets/word_card/audio/clock.mp3' },
  { name: '자동차', imageUrl: '/assets/word_card/images/car.png', audioUrl: '/assets/word_card/audio/car.mp3' },
  { name: '수영', imageUrl: '/assets/word_card/images/swimming.png', audioUrl: '/assets/word_card/audio/swimming.mp3' },


  // 동물
  { name: '강아지', imageUrl: '/assets/word_card/images/dog.png', audioUrl: '/assets/word_card/audio/dog.mp3' },
  { name: '기린', imageUrl: '/assets/word_card/images/giraffe.png', audioUrl: '/assets/word_card/audio/giraffe.mp3' },
  { name: '나비', imageUrl: '/assets/word_card/images/butterfly.gif', audioUrl: '/assets/word_card/audio/butterfly.mp3'},
  { name: '돼지', imageUrl: '/assets/word_card/images/pig.png', audioUrl: '/assets/word_card/audio/pig.mp3' },
  { name: '매미', imageUrl: '/assets/word_card/images/cicada.gif', audioUrl: '/assets/word_card/audio/cicada.mp3' },
  { name: '상어', imageUrl: '/assets/word_card/images/shark.png', audioUrl: '/assets/word_card/audio/shark.mp3' },
  { name: '원숭이', imageUrl: '/assets/word_card/images/monkey.gif', audioUrl: '/assets/word_card/audio/monkey.mp3'},
  { name: '코끼리', imageUrl: '/assets/word_card/images/elephant.gif', audioUrl: '/assets/word_card/audio/elephant.mp3' },
  { name: '토끼', imageUrl: '/assets/word_card/images/rabbit.gif', audioUrl: '/assets/word_card/audio/rabbit.mp3' },

  // 신체
  { name: '아파요', imageUrl: '/assets/word_card/images/sick.png', audioUrl: '/assets/word_card/audio/sick.mp3' },

   // 음식
  { name: '커피', imageUrl: '/assets/word_card/images/coffee.png', audioUrl: '/assets/word_card/audio/coffee.mp3' },
  { name: '김밥', imageUrl: '/assets/word_card/images/gimbap.png', audioUrl: '/assets/word_card/audio/gimbap.mp3' },
  { name: '햄버거', imageUrl: '/assets/word_card/images/hamburger.png', audioUrl: '/assets/word_card/audio/hamburger.mp3' },
  { name: '고기', imageUrl: '/assets/word_card/images/meat.png', audioUrl: '/assets/word_card/audio/meat.mp3' },
  { name: '우유', imageUrl: '/assets/word_card/images/milk.png', audioUrl: '/assets/word_card/audio/milk.mp3' },
  { name: '피자', imageUrl: '/assets/word_card/images/pizza.png', audioUrl: '/assets/word_card/audio/pizza.mp3' },

  // 학교
  { name: '가방', imageUrl: '/assets/word_card/images/bag.png', audioUrl: '/assets/word_card/audio/bag.mp3' },
  { name: '의자', imageUrl: '/assets/word_card/images/chair.png', audioUrl: '/assets/word_card/audio/chair.mp3' },
]